import { render } from "./AddCategorieArticle.vue?vue&type=template&id=7bc2a65c&ts=true"
import script from "./AddCategorieArticle.vue?vue&type=script&lang=ts"
export * from "./AddCategorieArticle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__